// extracted by mini-css-extract-plugin
module.exports = {"statusImage":"Dynamics_statusImage___Q2_t","englishData":"Dynamics_englishData__22UPs","label":"Dynamics_label__7c75m","data":"Dynamics_data__28SsD"};